import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent {
	title = "LMS Leads";
	env = environment;
	database = '';

	constructor(private http: HttpClient) {}

    ngOnInit(): void {
		this.getDatabaseName();
	}

	getDatabaseName() {
		this.http.get(`${environment.api}config/get_database`).subscribe(
			(data: any) => {
				this.database = data.body.database_name;
			},
			(error: any) => {
				console.error("Error fetching database name:", error);
			}
		);
	}
}
